import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
  selector: 'app-profile-modal',
  imports: [RouterModule, MatIconModule],
  templateUrl: './profile-modal.component.html',
  styleUrl: './profile-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileModalComponent implements OnInit {
  dialogRef = inject(DialogRef);
  datax = inject(DIALOG_DATA);
  profileItems: any[] = [];
  user = null;
  isAuthRoute: boolean = false;
  constructor(public router: Router, private authService: AuthService) {
    // Initialization logic can go here if needed
  }
  ngOnInit() {
    // add profile and logout items if user is authenticated
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  logout(): void {
    this.authService.signOut();
    this.dialogRef.close();
  }
}
